import { ROUTING_SANKEY_MEASURES } from 'cube/constants'
import * as R from 'ramda'

import type { CubeQuery } from '@driftt/dds.reports'

export const RoutingSankeyQuery: CubeQuery = {
  name: 'RoutingSankey',
  query: {
    measures: R.values(ROUTING_SANKEY_MEASURES),
  },
  queryName: 'RoutingSankey',
}
